var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg-226090312_876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    transform: "matrix(1 0 0 -1 0 63)",
    fill: "url(#svg-226090312_876_paint0_linear_355_72288)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 30.9542,
    transform: "matrix(1 0 0 -1 0 63)",
    stroke: "url(#svg-226090312_876_paint1_linear_355_72288)",
    strokeOpacity: 0.2,
    strokeWidth: 1.0916
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-226090312_876_paint0_linear_355_72288",
    x1: 31.5,
    y1: 0,
    x2: 31.5,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83828A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83828A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-226090312_876_paint1_linear_355_72288",
    x1: 28.374,
    y1: -24.5267,
    x2: 38.6119,
    y2: 40.2209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D172B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageBg);
export default __webpack_public_path__ + "static/media/image_bg.01c27fc1bcafe5b7b1892385cd95dcba.svg";
export { ForwardRef as ReactComponent };